<mat-toolbar class="mat-toolbar-height">
  <div class="div-title">
    <mat-icon>trending_up</mat-icon>
    <span>{{ isEdit ? ("events.metric_edit" | translate) : ("events.metric_add" | translate)}}</span>
  </div>
  <span class="tracker-spacer"></span>
  <button mat-icon-button mat-dialog-close="false">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-tab-group class="modal-style">
  <!-- Tab prédéfini -->
  <mat-tab class="tab">
    <ng-template mat-tab-label>
      <mat-icon class="tab-icon">insights</mat-icon>
      {{ 'events.predefined' | translate }}
    </ng-template>
    <div class="title-content">
    <p *ngIf="!isEdit" class="title-content-tab">
      {{ isEdit ? ('events.metric_edit_predefined' | translate) : ('events.metric_add_predefined' | translate) }}
    </p>
    <button mat-button color="primary" class="btn-config" (click)="goToSettings()">
      <mat-icon>settings</mat-icon>
      Configurer
    </button> 
  </div>
    <form class="tracker-form modal-style form">
      <div class="form-container">
        <mat-form-field appearance="outline">
          <mat-label>{{ "events.metric_model_name" | translate }} </mat-label>
          <mat-select name="model" [value]="currentModelIndex" (selectionChange)="onModelChanged($event)">
            <mat-option *ngFor="let model of metricModels; let index = index" [value]="index">{{ model.name
              }}</mat-option>
          </mat-select>
        </mat-form-field>
        <form *ngIf="currentModel?.payload && currentModel?.payload?.length" class="form">
          <!-- list -->
          <div *ngFor="let option of currentModel?.payload" [style.width]="option.widthDiv">
            <ng-container [ngTemplateOutlet]="selectForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'select'">
            </ng-container>
            <ng-container [ngTemplateOutlet]="textForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'text'">
            </ng-container>
            <ng-container [ngTemplateOutlet]="textareaForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'textarea'">
            </ng-container>
            <ng-container [ngTemplateOutlet]="numberForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'number'">
            </ng-container>
            <ng-container [ngTemplateOutlet]="dateForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'date'">
            </ng-container>
            <!-- TODO: Error in template -->
            <!-- <ng-container [ngTemplateOutlet]="checkboxForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'checkbox'">
            </ng-container> -->
            <!-- TODO: implement these templates -->
            <!-- <ng-container [ngTemplateOutlet]="radioForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'radio'">
            </ng-container>
            <ng-container [ngTemplateOutlet]="colorsForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'colors'">
            </ng-container>
            <ng-container [ngTemplateOutlet]="colorForm" [ngTemplateOutletContext]="{ config: option }"
              *ngIf="option.type == 'color'">
            </ng-container> -->
          </div>

          <!-- select -->
          <ng-template #selectForm let-config="config">
            <mat-form-field appearance="outline">
              <mat-label>{{ config.label }}</mat-label>
              <ng-container *ngIf="config.multiple">
                <mat-select matInput [(ngModel)]="config.value" [class]="config.customClass"
                  [ngModelOptions]="{ standalone: true }" size="5" multiple>
                  <mat-option [value]="opt" *ngFor="let opt of config.options">{{ opt }}</mat-option>
                </mat-select>
              </ng-container>
              <ng-container *ngIf="!config.multiple">
                <mat-select matInput [(ngModel)]="config.value" [ngModelOptions]="{ standalone: true }">
                  <mat-option [value]="opt" *ngFor="let opt of config.options">{{ opt }}</mat-option>
                </mat-select>
              </ng-container>
            </mat-form-field>
          </ng-template>

          <!-- text -->
          <ng-template #textForm let-config="config">
            <mat-form-field appearance="outline" class="" [style.width]="config.width">
              <mat-label>{{ config.label }}</mat-label>
              <input matInput type="text" placeholder="0" [(ngModel)]="config.value" [style.height]="config.height"
                [ngModelOptions]="{ standalone: true }" />
            </mat-form-field>
          </ng-template>

          <!-- textarea -->
          <ng-template #textareaForm let-config="config">
            <mat-form-field appearance="outline" class="" [style.width]="config.width">
              <mat-label>{{ config.label }}</mat-label>
              <textarea matInput placeholder="0" [(ngModel)]="config.value" [style.height]="config.height"></textarea>
            </mat-form-field>
          </ng-template>

          <!-- number -->
          <ng-template #numberForm let-config="config">
            <mat-form-field appearance="outline" class="" [style.width]="config.width">
              <mat-label>{{ config.label }}</mat-label>
              <input matInput type="number" placeholder="0" [(ngModel)]="config.value"
                [ngModelOptions]="{ standalone: true }" [min]="config.min !== undefined ? config.min : null"
                [max]="config.max !== undefined ? config.max : null" />
            </mat-form-field>
          </ng-template>

          <!-- date -->
          <ng-template #dateForm let-config="config">
            <div [style.width]="config.width">
              <label>{{ config.label }}</label>
              <app-date-picker [startDate]="config.value" (change)="onDateChange($event, config)"></app-date-picker>
            </div>
          </ng-template>

          <!-- checkbox -->
          <!-- TODO: fix errors (e.g. inputList not defined..) -->
          <!-- <ng-template #checkboxForm let-config="config">
            <mat-checkbox [(ngModel)]="config.value" [ngModelOptions]="{ standalone: true }"
              [style.width]="config.width || '250px'" [class]="config.customClass">
              {{ config.label }}</mat-checkbox>
            <div class="group box-input" *ngIf="config.groupKey && config.value">
              <ng-container [ngTemplateOutlet]="inputList" [ngTemplateOutletContext]="{ inputs: groups[config.group] }">
              </ng-container>
            </div>
          </ng-template> -->
        </form>
      </div>

      <mat-dialog-actions class="btn-actions">
        <button class="button-primary" mat-flat-button color="accent" (click)="exportMetric()">
          <div class="icon-btn">
            <mat-icon>save_alt</mat-icon>
            {{ "planning.export" | translate }}
          </div>
        </button>
        <div>
          <span class="tracker-spacer"></span>
          <button class="button-primary" mat-flat-button color="primary" (click)="saveMetric()">
            {{ "form.save" | translate }}
          </button>
          <button mat-button mat-dialog-close="false">
            {{ "form.close" | translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  </mat-tab>

  <!-- Tab import -->
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon class="tab-icon">file_upload</mat-icon>
      Import
    </ng-template>
    <div class="content-tab">
      <p class="title-content-tab">Importer votre fichier csv</p>
      <p>Seuls les fichiers .csv peuvent être importés.</p>
      <!-- <mat-card-content> </mat-card-content> -->
      <button class="button-primary" type="button" mat-raised-button (click)="fileInput.click()" color="primary">
        {{ "settings.project.choose_file" | translate }}
      </button>
      <!-- <input type="file" (change)="loadMetrics($event)" /> -->
      <input #fileInput hidden (change)="loadMetrics($event)" type="file" id="file" accept=".csv" />

      <!-- Progress bar display -->
      <div *ngIf="uploadInProgress">
        <mat-progress-bar mode="determinate" value="{{ uploadProgress }}"></mat-progress-bar>
      </div>

      <!-- Success display -->
      <div *ngIf="uploadProgress === 100 && !uploadError">
        <p class="success">{{ uploadSuccess }}</p>
      </div>

      <!-- Errors display -->
      <div *ngIf="uploadError">
        <p class="danger">{{ uploadError }}</p>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>